import {
	GetServerSideProps, GetServerSidePropsContext, GetServerSidePropsResult, NextPage,
} from 'next';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

import ClassicFooter from '@/components/classic/footer/ClassicFooter';

import ParcoursSlugPage from '@/components/classic/ParcoursSlugPage';
import { useCallback } from 'react';
import { useDevice } from '../../custom/useDevice';
import { fetchClassicExperience } from '../../data/ClassicExperience';
import { NextPageProps } from '../../typings/NextPageProps';
import { checkClient } from '../../utils/serverSide';

export const Parcours: NextPage<NextPageProps> = ({
	domainEnum, seo, host, client,
}: NextPageProps) => {
	const device = useDevice();
	const router = useRouter();
	const slug = router.query.slug as string;

	const onBack = useCallback(() => {
		router.push('/');
	}, [router]);

	return (
		<>
			<NextSeo {...seo} />

			<ParcoursSlugPage
				host={host}
				slug={slug}
				client={client}
				onBack={onBack}
			/>

			<ClassicFooter device={device} domainEnum={domainEnum} translation={client.attributes.translations} />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async (
	context: GetServerSidePropsContext,
) => {
	const nextProps = await checkClient(context, ['classic'], ['common']) as { props?: NextPageProps };

	if (!nextProps.props) {
		return nextProps as unknown as Promise<GetServerSidePropsResult<NextPageProps>>;
	}

	const { slug } = context.params as { slug: string };

	const classicExperience = await fetchClassicExperience(slug, context.locale || 'fr');

	return {
		props: {
			...nextProps.props,

			seo: {
				...nextProps.props.seo,

				title:       classicExperience?.attributes.descriptionTitle,
				description: classicExperience?.attributes.descriptionText,

				openGraph: {
					type:        'website',
					title:       classicExperience?.attributes.descriptionTitle,
					description: classicExperience?.attributes.descriptionText,
					site_name:   nextProps.props.seo.openGraph.site_name,
					url:         nextProps.props.seo.openGraph.url,
					images:      [
						{
							url: classicExperience
								? classicExperience.attributes.image.data.attributes.url : '',
							width: classicExperience
								? classicExperience.attributes.image.data.attributes.width : 0,
							height: classicExperience
								? classicExperience.attributes.image.data.attributes.height : 0,
						},
					],
				},
			},
		},
	};
};

export default Parcours;
